
<script>
import { defineComponent } from "vue";
import { Carousel, Navigation, Slide } from "vue3-carousel";

import "vue3-carousel/dist/carousel.css";

export default defineComponent({
  name: "Autoplay",
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  props: {
    count: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      breakpoints: {
        1000: {
          itemsToShow: 8,
        },
        500: {
          itemsToShow: 4,
        },
        400: {
          itemsToShow: 2,
        },
        200: {
          itemsToShow: 2,
        },
      },
    };
  },
});
</script>

<template>
  <Carousel
    :autoplay="0"
    :breakpoints="breakpoints"
    :wrapAround="true"
    :transition="500"
  >
    <Slide :id="slide" v-for="slide in count" :key="slide">
      <slot :name="slide">{{ slide }}</slot>
    </Slide>
    <template #addons>
      <Navigation />
    </template>
  </Carousel>
</template>


<style>
#carouselIAvoice .carousel__viewport {
  overflow: visible !important;
}

#carouselIAvoice .carousel__slide--clone {
  opacity: 0.5;
  filter: blur(3px);
  transition: 0.4s;
}

#carouselIAvoice .carousel__slide--visible {
  opacity: 1 !important;
  filter: blur(0px);
}

#carouselIAvoice button.carousel__prev,
#carouselIAvoice button.carousel__next {
  background-repeat: no-repeat;
  background-size: 35px;
  background-position: center center;
  width: 35px;
  height: 35px;
}

#carouselIAvoice button.carousel__prev {
  background-image: url("../../assets/icons/arrow-left.svg");
}

#carouselIAvoice button.carousel__next {
  background-image: url("../../assets/icons/cricle-arrow-right-black.svg");
}

#carouselIAvoice button svg {
  display: none;
}
</style>
